<div class="main-container">
  <div class="col-lg-7 left-panel">
    <div class="row left-panel-content">
      <div class="col-md-12 logo-sg">
        <img
          src="../../../../assets/imgs/logo-sg.png"
          class="logo-sg-img"
          alt=""
        />
      </div>
      <hr class="divider" />
      <form class="login-form">
        <img src="" alt="" />

        @if (mfaToken$ | async) {
          <!-- Etapa 2: segundo fator -->
          <div class="mfa-step">
            <p class="mfa-title">Verificação em duas etapas</p>
            <p class="mfa-help">
              @if (!useRecoveryCode) {
                Digite o código de 6 dígitos gerado pelo seu aplicativo
                autenticador.
              } @else {
                Digite um dos seus códigos de recuperação (10 letras e números,
                sem hífen). Cada código só pode ser usado uma vez.
              }
            </p>

            @if (!useRecoveryCode) {
              <p-inputotp
                class="mfa-otp mfa-otp-code"
                [formControl]="inputMfaCode"
                [length]="6"
                [integerOnly]="true"
                [autofocus]="true"
                (keydown.enter)="loginMfa()"
              />
            } @else {
              <p-inputotp
                #recoveryOtp
                class="mfa-otp mfa-otp-recovery"
                [formControl]="inputRecoveryCode"
                [length]="10"
                [integerOnly]="false"
                [autofocus]="true"
                (keydown)="onRecoveryKeydown($event)"
                (keydown.enter)="loginMfa()"
              />
            }

            <label class="mfa-recovery-toggle">
              <input
                type="checkbox"
                [checked]="useRecoveryCode"
                (change)="toggleRecoveryCode($event)"
              />
              Entrar com código de recuperação
            </label>

            <div class="buttons">
              @if (loading$ | async) {
                <mat-spinner [diameter]="50"></mat-spinner>
              } @else {
                <button
                  type="button"
                  class="btn btn-primary"
                  id="mfaBtn"
                  [disabled]="
                    useRecoveryCode
                      ? inputRecoveryCode.invalid
                      : inputMfaCode.invalid
                  "
                  (click)="loginMfa()"
                >
                  Verificar
                </button>
                <p (click)="backToLogin()">Voltar</p>
              }
            </div>
          </div>
        } @else {
          <!-- Etapa 1: usuário e senha (igual ao original) -->
          <input
            [formControl]="inputUser"
            type="text"
            id="email"
            placeholder="Usuário"
            (keydown.enter)="login()"
          />
          <div class="password-field">
            <input
              [formControl]="inputPassword"
              (keydown.enter)="login()"
              [type]="isShowingPassword ? 'text' : 'password'"
              id="password"
              placeholder="Senha"
              class="passw-input"
            />

            @if (!isShowingPassword) {
              <mat-icon
                class="eye-icon"
                (click)="showPassword()"
                svgIcon="bx-show-green"
              ></mat-icon>
            }

            @if (isShowingPassword) {
              <mat-icon
                class="eye-icon"
                (click)="showPassword()"
                svgIcon="bx-hide-green"
              ></mat-icon>
            }
          </div>
          <div class="buttons">
            @if (loading$ | async) {
              <mat-spinner [diameter]="50"></mat-spinner>
            } @else {
              <button
                type="button"
                class="btn btn-primary"
                id="loginBtn"
                (click)="login()"
              >
                Entrar
              </button>
              <p>Recuperar senha</p>
            }
          </div>
        }

        @if (loginErrorMessage) {
          <div class="error-message" [innerHTML]="loginErrorMessage"></div>
        }
      </form>
    </div>
  </div>
  <div class="col-lg-5 right-panel">
    <div class="right-panel-text">
      <h1>Telegestão de iluminação pública</h1>
      <p>
        Automação da gestão de iluminação pública com redução de custos
        operacionais e redução do consumo de energia.
      </p>
    </div>
    <div class="round-box1"></div>
    <div class="circle1"></div>
    <div class="round-box2"></div>
    <div class="circle2"></div>
    <div class="triangle"></div>
  </div>
</div>
